import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Container,
  Alert,
  AlertIcon
} from '@chakra-ui/react';
// FaGoogle icon not used with GoogleLogin component
import { GoogleLogin } from '@react-oauth/google';
import { AuthContext } from '../context/AuthContext';

function Login() {
  const { loginWithGoogle, error, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const bgColor = useColorModeValue('white', 'gray.700');

  return (
    <Container maxW="md" py={12}>
      <Box bg={bgColor} p={8} rounded="md" boxShadow="lg">
        <VStack spacing={6}>
          <Heading as="h1" size="xl">Sign In</Heading>
          <Text>Sign in to Wishfin Env Manager using your Google account</Text>
          
          {error && (
            <Alert status="error" rounded="md">
              <AlertIcon />
              {error}
            </Alert>
          )}
          
          <Box w="full" py={4}>
            <GoogleLogin
              onSuccess={(credentialResponse) => {
                loginWithGoogle(credentialResponse.credential);
              }}
              onError={() => {
                console.log('Login Failed');
              }}
              useOneTap
              width="100%"
            />
          </Box>
        </VStack>
      </Box>
    </Container>
  );
}

export default Login;
